/** Change this once when you rename the fork. localStorage keys are per-origin. */
export const SAVE_GAME_KEY = 'phaser-ts-starter:save';
